import React, { useState } from 'react';
import Button from '../../common/ui/Button';
import { formatIsoDateToReadable } from '../../../utils/dates';
import DeviceReactivationModal from './DeviceReactivationModal';
import { useGetSubscriptionReactivationCostQuery } from '../../../redux/subscriptionsApi';

const DeviceReactivation = ({
  reactivationHandle,
  cancelledAt,
  className,
  subId,
  isLoading,
}) => {
  const formattedTime = formatIsoDateToReadable(cancelledAt);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    data: reactivationCostData,
    isLoading: reactivationCostIsLoading,
    error,
  } = useGetSubscriptionReactivationCostQuery(subId, {
    skip: !isModalOpen,
  });

  const openReactivationPopup = () => {
    setIsModalOpen(true);
  };
  const closeReactivationPopup = () => {
    setIsModalOpen(false);
  };

  const isModalLoading = isLoading || reactivationCostIsLoading;
  return (
    <>
      <div className={className}>
        <p>
          <span>Subscription Expired Since</span>
          {formattedTime}
        </p>
        <Button onClick={openReactivationPopup}>Reactivate Subscription</Button>
      </div>
      <DeviceReactivationModal
        submitHandler={reactivationHandle}
        onClose={closeReactivationPopup}
        costData={reactivationCostData}
        error={error}
        isOpen={isModalOpen}
        isLoading={isModalLoading}
      />
    </>
  );
};

export default DeviceReactivation;
